import {inject, Injectable, signal} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {Client, LoginRequest} from "@/api/client";
import {JwtHelperService} from "@auth0/angular-jwt";
import {catchError, Observable, tap, throwError} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})

export class AuthService {
    http = inject(HttpClient)
    router = inject(Router)
    client = inject(Client)
    jwtHelper = new JwtHelperService();
    logoutInProgress = false;
    token = signal<string | null>(this.getAccessToken())
    isAuth = signal<boolean>(false)

    constructor() {
        this.authCheck()
    }

    login(loginRequest: LoginRequest): Observable<boolean> {
        return this.client.account_LoginAdmin(loginRequest).pipe(
            tap((data) => {
                if (!data?.accessToken) {
                    throw new Error('Некорректный ответ сервера');
                }

                this.setTokens(data.accessToken.token!, data.refreshToken!);
                this.isAuth.set(true);
                this.router.navigate(['/settings']);
            }),
            map(() => true),
            catchError((error) => {
                const message =
                    error?.error?.message ||
                    error?.message ||
                    'Ошибка авторизации';

                return throwError(() => message);
            })
        );
    }

    authCheck() {
        if (this.token() && !this.jwtHelper.isTokenExpired(this.token())) {
         this.isAuth.set(true);}
    }

    isTokenValid():boolean {
        return !this.jwtHelper.isTokenExpired(this.getAccessToken());
    }

    logout() {
        if (this.logoutInProgress) {
            return;
        }

        this.logoutInProgress = true;

        this.client.account_LogOut().subscribe({
            next: () => {},
            error: () => {},
            complete: () => {
                this.isAuth.set(false);
                this.clearTokens()
                this.router.navigate(['/login']);
                this.logoutInProgress = false;
            }
        });
    }

    public clearTokens() {
        window.localStorage.removeItem('accessToken');
        window.localStorage.removeItem('refreshToken');
    }

    public setTokens(access_token: string, refresh_token: string) {
        window.localStorage.setItem('accessToken', access_token);
        window.localStorage.setItem('refreshToken', refresh_token);
    }

    public getAccessToken() {
        if (window.localStorage.getItem('accessToken') != null) {
            return window.localStorage.getItem('accessToken');
        }
        return null;
    }

    public getRefreshToken() {
        return window.localStorage.getItem('refreshToken');
    }

}
